export type Project = {
  id: string;
  /** Client name, or a label for non-case-study tiles */
  client: string;
  title: string;
  description: string;
  tags: string[];
  href: string;
  /** "invite" renders the more-work tile instead of a case study */
  kind: "case-study" | "invite";
  image?: string;
  /** CSS mask-image marking where trees sway in the photo */
  motionMask?: string;
  motionStyle?: "foliage" | "branches" | "water";
  cta?: string;
};

export const projects: Project[] = [
  {
    id: "lawrence-responsible-ai",
    client: "Lawrence University",
    title: "Responsible AI, Before the Rules",
    description: "Building a human-centered framework for responsible AI exploration.",
    tags: ["AI Governance", "Responsible Tech"],
    href: "/work/lawrence-responsible-ai",
    kind: "case-study",
    image:
      "https://cdn.magicpatterns.com/uploads/tA1iU8HpjBuHVenTLtm4zf/about-hero.jpg",
    motionMask: "radial-gradient(ellipse 50% 62% at 66% 62%, #000 60%, transparent 100%)",
    motionStyle: "foliage",
  },
  {
    id: "lawrence-website",
    client: "Lawrence University",
    title: "A Website That Keeps Learning",
    description: "10,000+ pages transformed into a focused, evolving web product.",
    tags: ["Digital Transformation", "Web Product"],
    href: "/work/lawrence-website",
    kind: "case-study",
    image:
      "https://cdn.magicpatterns.com/uploads/1n4MbxHZzc3Vddr7bEKkPF/gettingtolawrence_b.jpg",
    // Only the river below the bridge and shoreline
    motionMask: "linear-gradient(to bottom, transparent 0%, transparent 58%, #000 64%, #000 100%)",
    motionStyle: "water",
  },
  {
    id: "wooster-enrollment-journey",
    client: "The College of Wooster",
    title: "The Journey Before the Website",
    description:
      "Connecting digital behavior, marketing technology and the enrollment journey.",
    tags: ["Customer Journey", "Martech"],
    href: "/work/wooster-enrollment-journey",
    kind: "case-study",
    image:
      "https://cdn.magicpatterns.com/uploads/ub2qhp2wDRJwDG6ZRL3Uhz/wooster.jpg",
    motionMask:
      // Only the bare trees above the rooflines, clear of the tower and wings
      "radial-gradient(ellipse 20% 30% at 6% 6%, #000 60%, transparent 100%), radial-gradient(ellipse 17% 24% at 96% 6%, #000 60%, transparent 100%)",
  },
  {
    id: "more-work",
    client: "More Work",
    title: "Curious? There’s More.",
    description: "Looking for something specific? I probably have a story.",
    tags: ["More Work", "Just Ask"],
    href: "/#contact",
    kind: "invite",
    cta: "Request more",
  },
];
